var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurgicaldisposables(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 98 97.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "XMLID_908_",
    x: 25.072,
    y: 57.985,
    width: 33.514,
    height: 33.516,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "XMLID_918_",
    x: 58.015,
    y: 57.984,
    width: 33.517,
    height: 33.517,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "XMLID_921_",
    x: 18.602,
    y: 0,
    width: 79.398,
    height: 97.973,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "XMLID_1030_",
    x: 0,
    y: 0,
    width: 39.867,
    height: 92.69,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "XMLID_1032_",
    x: 16.869,
    y: 29.956,
    width: 21.124,
    height: 21.124,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Surgical_disposables",
    "data-name": "Surgical & disposables",
    transform: "translate(9 5.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_871_",
    transform: "translate(0 0.089)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#XMLID_908_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_908_2",
    "data-name": "XMLID_908_",
    d: "M170.278,371.586a7.756,7.756,0,1,0,5.485,9.5A7.765,7.765,0,0,0,170.278,371.586Zm2.467,8.691a4.633,4.633,0,1,1-3.275-5.673A4.6,4.6,0,0,1,172.745,380.277Z",
    transform: "translate(-126.44 -307.34)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#XMLID_918_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_918_2",
    "data-name": "XMLID_918_",
    d: "M377.175,371.584a7.758,7.758,0,0,0,1.995,15.251,7.8,7.8,0,0,0,2.02-.268,7.756,7.756,0,1,0-4.015-14.983Zm6.016,9.806a4.629,4.629,0,1,1,.465-3.514A4.6,4.6,0,0,1,383.191,381.391Z",
    transform: "translate(-304.41 -307.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#XMLID_921_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_921_2",
    "data-name": "XMLID_921_",
    d: "M180,62.149A14.239,14.239,0,0,0,162.547,52.1a4.631,4.631,0,0,1-3.519-.427,4.426,4.426,0,0,1-2.086-2.711l-2.213-8.2,1.5-5.586a1.561,1.561,0,0,0,1.448-1.163l3.691-14.078a23.4,23.4,0,0,0-3.2-19.154,1.562,1.562,0,0,0-2.8.473l-5.569,21.015L144.222,1.251a1.562,1.562,0,0,0-2.8-.473,23.4,23.4,0,0,0-3.2,19.145l3.693,14.087a1.561,1.561,0,0,0,1.448,1.163l1.5,5.586-2.214,8.205a4.424,4.424,0,0,1-2.086,2.71,4.628,4.628,0,0,1-3.517.427A14.229,14.229,0,1,0,140.4,78.166a14.485,14.485,0,0,0,6.441-8.007c.01-.03-.008.03,0,0l2.946-10.984,2.946,10.984c.008.03-.01-.03,0,0a14.486,14.486,0,0,0,6.441,8.007A14.225,14.225,0,0,0,180,62.149ZM157.38,5.825a20.29,20.29,0,0,1,.965,13.306l-3.379,12.921c-.085,0-2.581,0-2.581,0l-.978-3.689Zm-16.144,13.3a20.281,20.281,0,0,1,.967-13.3l6.95,26.227s-4.452,0-4.536,0Zm2.618,50.136a11.244,11.244,0,0,1-5.006,6.2,11.1,11.1,0,1,1-2.627-20.342,7.708,7.708,0,0,0,5.888-.733,7.526,7.526,0,0,0,3.548-4.607l.81-3,1.707,6.369Zm25.283,7.3a11.059,11.059,0,0,1-13.408-7.3l-9.137-34.083h3.395l3.939,14.6a7.527,7.527,0,0,0,3.549,4.61,7.711,7.711,0,0,0,5.889.732,11.1,11.1,0,1,1,5.774,21.438Z",
    transform: "translate(-91.49 5.91)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#XMLID_1030_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1030_2",
    "data-name": "XMLID_1030_",
    d: "M19.993,49.065V38.635a1.562,1.562,0,1,0-3.124,0V47.5H5v-3.86h5.519a1.562,1.562,0,1,0,0-3.124H5V36.66H7.185a1.562,1.562,0,1,0,0-3.124H5v-3.86h5.519a1.562,1.562,0,1,0,0-3.124H5v-3.86H7.185a1.562,1.562,0,1,0,0-3.124H5v-3.86H16.869v8.868a1.562,1.562,0,0,0,3.124,0V15.709h.312a1.562,1.562,0,1,0,0-3.124H16.244V3.213h.937a1.562,1.562,0,1,0,0-3.124H4.686a1.562,1.562,0,1,0,0,3.124h.937v9.372H1.562a1.562,1.562,0,1,0,0,3.124h.312V49.065a1.562,1.562,0,0,0,1.562,1.562H5.623v7.185a1.562,1.562,0,0,0,1.562,1.562H9.372V73.218a1.562,1.562,0,1,0,3.124,0V59.374h2.187a1.562,1.562,0,0,0,1.562-1.562V50.627h2.187A1.562,1.562,0,0,0,19.993,49.065ZM8.747,3.213H13.12v9.372H8.747ZM13.12,56.25H8.747V50.627H13.12Z",
    transform: "translate(9 5.91)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#XMLID_1032_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1032_2",
    "data-name": "XMLID_1032_",
    d: "M109.561,191.869a1.563,1.563,0,1,0,1.1.458A1.567,1.567,0,0,0,109.561,191.869Z",
    transform: "translate(-82.13 -155.91)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgicaldisposables);
export default __webpack_public_path__ + "static/media/Surgical & disposables.47cea3b83954d95df4ff80ee50a5e2a0.svg";
export { ForwardRef as ReactComponent };